export const rooms = [
  {
    id: 'room-1',
    title: 'The Sunday Morning Living Space',
    subtitle: 'Warm Terracotta & Natural Linen',
    description: 'Bathed in natural light, this space is anchored by grounding textures. Layered textiles and sculptural ceramics create an effortless, lived-in elegance perfect for slow weekends.',
    image: 'https://images.unsplash.com/photo-1583847268964-b28dc2f51ac9?auto=format&fit=crop&w=1600&q=80',
    products: [
      {
        id: 101,
        name: 'Bouclé Accent Chair',
        price: 895,
        image: 'https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?auto=format&fit=crop&w=400&q=80'
      },
      {
        id: 102,
        name: 'Hand-knotted Jute Rug',
        price: 450,
        image: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?auto=format&fit=crop&w=400&q=80'
      },
      {
        id: 103,
        name: 'Terracotta Table Lamp',
        price: 185,
        image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=400&q=80'
      },
    ]
  },
  {
    id: 'room-2',
    title: 'The Serene Sanctuary Bedroom',
    subtitle: 'Washed Cotton & Warm Wood',
    description: 'A restful retreat designed for complete decompression. Soft, breathable layers meet minimalist wooden frames to cultivate a space of quiet reflection and deep rest.',
    image: 'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?auto=format&fit=crop&w=1600&q=80',
    products: [
      {
        id: 201,
        name: 'Washed Linen Duvet Set',
        price: 280,
        image: 'https://images.unsplash.com/photo-1522771731478-44eb10e5c776?auto=format&fit=crop&w=400&q=80'
      },
      {
        id: 202,
        name: 'Walnut Bedside Table',
        price: 320,
        image: 'https://images.unsplash.com/photo-1532372320572-cda25653a26d?auto=format&fit=crop&w=400&q=80'
      },
      {
        id: 203,
        name: 'Alabaster Sconce',
        price: 145,
        image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=400&q=80'
      },
    ]
  }
];

export const bundles = [
  {
    id: 'bundle-1',
    name: 'The Essential Lighting Bundle',
    price: 450,
    originalPrice: 520,
    image: 'https://images.unsplash.com/photo-1534073828943-f801091bb18c?auto=format&fit=crop&w=800&q=80',
    tag: 'Save 15%'
  },
  {
    id: 'bundle-2',
    name: 'Autumn Textiles Set',
    price: 295,
    originalPrice: 350,
    image: 'https://images.unsplash.com/photo-1606744881024-52e8019a593d?auto=format&fit=crop&w=800&q=80',
    tag: 'Bestseller'
  },
  {
    id: 'bundle-3',
    name: 'Dining Table Scape',
    price: 180,
    originalPrice: 210,
    image: 'https://images.unsplash.com/photo-1603912627214-9011de995d9d?auto=format&fit=crop&w=800&q=80',
    tag: 'New'
  }
];

export const reviews = [
  {
    id: 1,
    text: "CozyNest completely transformed my living room. The pieces feel curated and soulful, not mass-produced. The quality is exceptional.",
    author: "Elena M.",
    location: "Brooklyn, NY"
  },
  {
    id: 2,
    text: "Shopping the room mood boards made styling my new apartment effortless. Everything arrived beautifully packaged.",
    author: "James T.",
    location: "Austin, TX"
  },
  {
    id: 3,
    text: "The linen bundle is the softest I've ever owned. You can feel the intention and care put into sourcing these materials.",
    author: "Sarah L.",
    location: "Portland, OR"
  }
];

export const faqs = [
  {
    question: "Do you offer interior styling services?",
    answer: "While we don't offer bespoke 1-on-1 styling, our 'Shop the Room' collections are designed by our in-house interior stylists to give you a cohesive, professional look effortlessly."
  },
  {
    question: "What is your return policy?",
    answer: "We accept returns within 30 days of delivery for all unused items in their original packaging. Custom or final sale items are non-returnable. Please visit our Returns page to initiate a process."
  },
  {
    question: "How long does shipping take?",
    answer: "In-stock items typically ship within 2-3 business days. Depending on your location, standard transit times range from 3-7 business days. Freight items (like large furniture) may take 2-4 weeks."
  }
];